import { useState } from 'react';
import { cx } from '@/shared/lib/cx';
import s from './Display.module.css';

/** Инициалы из имени (поддерживает казахские буквы): «Әлия Нұрланқызы» → «ӘН». */
export function initialsOf(name: string): string {
  const words = name
    .trim()
    .split(/[\s-]+/)
    .filter((word) => /\p{L}/u.test(word));
  const letters = words.slice(0, 2).map((word) => Array.from(word.replace(/[^\p{L}]/gu, ''))[0] ?? '');
  return letters.join('').toLocaleUpperCase('kk');
}

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  /** Имя уже написано рядом — аватар скрыт от экранных дикторов. */
  decorative?: boolean;
  className?: string;
}

export function Avatar({ name, src, size = 'md', decorative = true, className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const sizeClass = size === 'sm' ? s.avatarSm : size === 'lg' ? s.avatarLg : s.avatarMd;
  return (
    <span className={cx(s.avatar, sizeClass, className)} aria-hidden={decorative ? true : undefined} role={decorative ? undefined : 'img'} aria-label={decorative ? undefined : name}>
      {src && !failed ? <img src={src} alt="" onError={() => setFailed(true)} /> : initialsOf(name)}
    </span>
  );
}
